import { createReducer, on, Action, ActionCreator } from '@ngrx/store';
import { ofType } from '@ngrx/effects';
import {Observable, merge} from 'rxjs';
import { map } from 'rxjs/operators';
import { asyncActionState, AsyncActionQueries } from './async-action-state';
import {State} from '@emm/auth/store/auth.reducer';

export function sortByWeight(a: { weight?: number | string }, b: { weight?: number }): number {
    return +a.weight > +b.weight ? -1 : 1;
}

// withLoadable credit https://github.com/ngrx/platform/issues/1956#issuecomment-526720340
export function withLoadable({ loadAction, successAction, errorAction }) {
    return (initialState: State, ...ons: any[]) =>
        createReducer<State>(
            initialState,
            on(loadAction, (state) => ({ ...state, ...asyncActionState.loading })),
            on(successAction, (state) => ({ ...state, ...asyncActionState.success })),
            on(errorAction, (state, { error }) => ({ ...state, ...asyncActionState.error(error) })),
            ...ons
        );
}

export function withLoadables<S>(asyncActions: {
    errorActions: ActionCreator[];
    loadActions: ActionCreator[];
    successActions: ActionCreator[];
}) {
    return (initialState: S, ...ons: any[]) =>
        createReducer<S>(
            initialState,
            // @ts-ignore
            on(...asyncActions.loadActions, (state) => ({ ...state, ...asyncActionState.loading })),
            // @ts-ignore
            on(...asyncActions.successActions, (state) => ({ ...state, ...asyncActionState.success })),
            // @ts-ignore
            on(...asyncActions.errorActions, (state, { error }) => ({
                ...state,
                ...asyncActionState.error(error),
            })),
            ...ons
        );
}

export interface ActionQueries {
    [key: string]: Observable<Action> | Observable<object>;
}

export function getActionQueries({ actionCreators, actions$ }): ActionQueries {
    return Object.keys(actionCreators).reduce((acc: ActionQueries, cur: string) => {
        const action: ActionCreator = actionCreators[cur];
        return {
            ...acc,
            [action.type]: actions$.pipe(ofType(action)),
        };
    }, {});
}

export function asyncActionToBoolean(
    queries: AsyncActionQueries,
    successAction: string,
    failureAction: string): Observable<any> {
    return merge(queries[successAction].pipe(map(() => true)), queries[failureAction].pipe(map(() => false)));
}
